import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, Card, Checkbox, Chip, Divider, FormControl, Grid, IconButton, InputAdornment, LinearProgress, Link, Menu, MenuItem, Paper, Radio, Select, Stack, TextField, Typography } from '@mui/material'
import React, { useMemo, useState } from 'react'
import statusIcon from "../../../assets/svg/Check icon.svg"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ArrowForward, CloseOutlined, } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import agentimg from "../../../assets/svg/Ellipse 12.svg"
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from "@mui/icons-material/Check";
import { SlPresent } from "react-icons/sl";
import { LuPen, LuUsersRound } from "react-icons/lu";
import { LuSend } from "react-icons/lu";
import { FaMinusCircle, FaPlusCircle, FaRegIdCard, FaRegUser } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import { RiUserForbidLine } from "react-icons/ri";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Modal } from 'react-bootstrap';
import { IoCallOutline, IoTrophyOutline, IoWarningOutline } from 'react-icons/io5';
import { MdOutlineContentCopy, MdOutlineEmail, MdOutlinePhoneAndroid, MdOutlineSms } from 'react-icons/md';
import { CiCalendar } from "react-icons/ci";
import { IoIosCloseCircle, IoIosRemoveCircle, IoIosTrendingUp } from "react-icons/io";
import { AiOutlinePlus } from "react-icons/ai";
import { HiOutlineMinus } from "react-icons/hi";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BsArrowRight } from 'react-icons/bs';
import dayjs from 'dayjs';
import EstbnLogo from "../../../assets/svg/estbn-logo.svg"
const Members = () => {

// members 

    const membersStats = [
        { title: "Total Members", value: 24568, subtitle: "18% vs last 30 days" },
        { title: "Active Members", value: 18765, subtitle: "8% vs last 30 days" },
        { title: "Members Earning Points", value: 21340, subtitle: "14% vs last 30 days" },
        { title: "Members Redeeming Points", value: 9845, subtitle: "14% vs last 30 days" },
      
            ];
            const [selectedRows, setSelectedRows] = useState([]);
            const [selectedInfoRows, setSelectedInfoRows] = useState([]);
            const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
            const [menuState, setMenuState] = useState({ anchorEl: null, row: null });
        
            const handleClose = () => setMenuState({ anchorEl: null, row: null });
            const handleClick = (event, row) => setMenuState({ anchorEl: event.currentTarget, row });
        
            const handleActivate = () => console.log(selectedRows);
            const handleReset = () => setSelectedRows([]);
            const handlePause = () => console.log(selectedRows);
            const handleDelete = () => console.log(selectedRows);
    

             const membersColumns = [
  
        { field: "name", headerName: "Member", flex: 1.2, minWidth: 150,
                  renderCell: (params) => { 
            return(
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 1, gap:1 }}>
                    <Avatar src={params.row.member.img}></Avatar>
                    <Box textAlign={"start"}>
                        <Typography fontSize={12}>{params.row.member.name}</Typography>
                        <Typography fontSize={12} color='#535353'>{params.row.member.phone}</Typography>
                    </Box>
                </Box>
            )
        }
         },
        {
            field: "tier",
            headerName: "Tier",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p:1 }}>
                        <Chip
                            label={params.row.tier.name}
                            size="medium"
                            sx={{ bgcolor: params.row.tier?.bgColor, fontWeight: 500,  px:2}}
                        />
                       
                    </Box>
                );
            },
        },
        { field: "points_balance", headerName: "Points Balance", flex: 0.8, minWidth: 100 },
        { field: "total_earned", headerName: "Total Earned", flex: 0.8, minWidth: 100 },
        { field: "total_redeemed", headerName: "Total Redeemed", flex: 0.8, minWidth: 100 },
        { field: "total_orders", headerName: "Total Orders", flex: 0.6, minWidth: 90 },
        { field: "join_date", headerName: "Join Date", flex: 0.8, minWidth: 100 },
        { field: "last_activity", headerName: "Last Activity", flex: 0.5, minWidth: 100 },
           {
                    field: "status",
                    headerName: "Status",
                    flex: 1,
                    minWidth: 150,
                    renderCell: (params) => {
                        return (
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 1 }}>
                                <Chip
                                    label={params.row.status.name}
                                    size="medium"
                                    sx={{ bgcolor: params.row.status?.bgColor, fontWeight: 500, px:2 }}
                                />
                             
                            </Box>
                        );
                    },
                },
    
            {
            field: "actions",
            headerName: "Actions",
            flex: 0.8,
            minWidth: 100,
            sortable: false,
            renderCell: (params) => (
                <>
                    <IconButton
                        disableRipple
                        size="small"
                        onClick={(e) => {
                            handleClick(e, params.row);
                            e.stopPropagation();
                        }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    <Menu
                        anchorEl={menuState.anchorEl}
                        open={Boolean(menuState.anchorEl)}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
                        slotProps={{ paper: { sx: { borderRadius: 2, p: 1, backgroundColor: "#F9F9F9" } } }}
                    >
                        <MenuItem onClick={handleAddBonusPointsOpen} className='p-2' sx={{ display: "flex", gap: 1, borderRadius: 1, 
                        }}>
                            <SlPresent color='#04B22E' fontSize="16" /> Add Bonus Points
                        </MenuItem>
                        <MenuItem onClick={handleAdjustPointsOpen} className='p-2' sx={{ display: "flex", gap: 1, borderRadius: 1,}}>
                            <LuPen fontSize="16" /> Adjust Points
                        </MenuItem>
                        <MenuItem onClick={handleSendNotificationsOpen} className='p-2' sx={{ display: "flex", gap: 1, borderRadius: 1,  }}>
                            <LuSend fontSize="16" /> Send Notification
                        </MenuItem>
                        <MenuItem onClick={handleClientProfileOpen} className='p-2'  sx={{ display: "flex", gap: 1, borderRadius: 1, }}>
                            <FaRegUser fontSize="16" />  Open Client Profile
                        </MenuItem>
                        <MenuItem onClick={handleChangeTierOpen} className='p-2' sx={{ display: "flex", gap: 1, borderRadius: 1,   }}>
                            <FaRegStar color= "#FEB91E" fontSize="16"  /> Change Tier
                        </MenuItem>
                        <Divider orientation='horizontal' flexItem />
                        <MenuItem onClick={handleSuspendMembershipOpen} className='p-1'  sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#A80101" , }}>
                            <RiUserForbidLine fontSize="16" /> Suspend Membership
                        </MenuItem>
                    </Menu>
                </>
            ),
        },
     
     
    ];

    const membersRows = [
        {
            id: "001", member:{name: "Ahmed Mohamed", phone:"0100 123 4567", img: agentimg}, tier: { name: "Platinum", bgColor: "#F6E9FC",}, points_balance: "12,850 pts", total_earned: "45,600 pts",
            total_redeemed: "33,750 pts", total_orders: 48, join_date: "Jan 10, 2024", last_activity: "May 31, 2025",
            status: { name: "Active", bgColor: "#ECF9F7"},
        },
        {
            id: "002", member:{name: "Sara Ahmed", phone:"0100 123 4567", img: agentimg}, tier: { name: "Gold", bgColor: "#FFFAEA",}, points_balance: "8,760 pts", total_earned: "28,400 pts",
            total_redeemed: "33,750 pts", total_orders: 41, join_date: "Jan 10, 2024", last_activity: "May 31, 2025",
            status: { name: "Active", bgColor: "#ECF9F7"},
        },
        {
            id: "003", member:{name: "Mostafa Ali", phone:"0100 123 4567", img: agentimg}, tier: { name: "Silver", bgColor: "#F0F8FF",}, points_balance: "19,640 pts", total_earned: "22,100 pts",
            total_redeemed: "14,560 pts", total_orders: 38, join_date: "Jan 10, 2024", last_activity: "May 31, 2025",
            status: { name: "Active", bgColor: "#ECF9F7"},
        },
      
    ]; 
    const memberDetails = {
     name:"Ahmed Mohamed",
     info: [
        {
            icon: <IoCallOutline/>,
            label:"0101 234 5678"
        },
          {
            icon: <MdOutlineEmail/>,
            label:"ahmed.mohamed@gmail.com"
          },
          {
            icon: <FaRegIdCard/>,
            label:"Member ID: ESTBN-00012345",
          },
          {
            icon: <CiCalendar/>,
            label: "Join Date: Jan 10, 2024"
          }
    
    ],
    img: agentimg,

    tier:{
        name: "Platinum",
        bgColor:"#F6E9FC"
    },

    last_active:"May 31, 2025",
    total_order:"48",
    total_spend:"32,450 EGP",
    avg_order_value:"676 EGP",
    member_since:"1 year, 4 month",
    referral_code:"AHMED2024"

   
    }
    // client profile

         const [openClientProfile, setOpenClientProfile] = useState(false);
         

  const handleClientProfileOpen = () =>{
     handleClose()
     setOpenClientProfile(true);
  }
  const handleClientProfileClose = () => setOpenClientProfile(false);
  

        const [openAddBonusPoints, setOpenAddBonusPoints] = useState(false);
        const [expandedPoints, setExpandedPoints] = useState(null);
        const [bonusStep, setBonusStep] = useState("form");

        const [bonusPoints, setBonusPoints] = useState(500);
        const [reason, setReason] = useState("Marketing Campaign");
        const [expiration, setExpiration] = useState("No Expiration");
        const [notes, setNotes] = useState("");

  const totalSelectedMembers = membersRows?.length || 0;
  const totalPointsToBeAdded = Number(bonusPoints || 0) * totalSelectedMembers;

  const handleAddBonusPointsOpen = () =>{
     handleClose()
     setOpenAddBonusPoints(true);
  }
  const handleAddBonusPointsClose = () => setOpenAddBonusPoints(false);
  const handleFullClose = () => {
    setBonusStep("form");
    handleAddBonusPointsClose();
  };

  const handlePreviewImpact = () => {
    setBonusStep("preview");
  };

  const handleBackToForm = () => {
    setBonusStep("form");
  };

  const handleConfirmAddPoints = () => {
    console.log({ bonusPoints, reason, expiration, notes, membersRows });
    handleFullClose();
  };


  // Change Tiers
const [openChangeTier, setOpenChangeTier] = useState(false);
const [expandedChangeTier, setExpandedChangeTier] = useState(null);
const [tierStep, setTierStep] = useState("form");

const [newTier, setNewTier] = useState("");
const [reasonChangeTier, setReasonChangeTier] = useState("");
const [notesChangeTier, setNotesChangeTier] = useState("");

const handleChangeTierOpen = () => {
  handleClose();
  setOpenChangeTier(true);
};
const handleChangeTierClose = () => setOpenChangeTier(false);

const totalSelectedMembersChangeTier = membersRows?.length || 0;

const handleChangeTierFullClose = () => {
  setTierStep("form");
  handleChangeTierClose();
};

const handlePreviewChangeTierImpact = () => {
  setTierStep("preview");
};

const handleBackChangeTierToForm = () => {
  setTierStep("form");
};

const handleConfirmChangeTier = () => {
  console.log({ newTier, reasonChangeTier, notesChangeTier, membersRows });
  handleChangeTierFullClose();
};

const tierColors = {
  Bronze: { bgcolor: "#FFF4F0", dot: "#FC6C4F" },
  Silver: { bgcolor: "#F0F8FF", dot: "#3E9FF6" },
  Gold: { bgcolor: "#FFFAEA", dot: "#FEB91E" },
  Platinum: { bgcolor: "#F6E9FC", dot: "#7E1BAD" },
};

const [tierDistributionRaw] = useState([
  { tier: "Bronze", count: 18000, percent: "60.6%" },
  { tier: "Silver", count: 3000, percent: "10.2%" },
  { tier: "Gold", count: 2500, percent: "8.6%" },
  { tier: "Platinum", count: 500, percent: "5.1%" },
]);

const tierDistribution = useMemo(() => {
  return tierDistributionRaw.map((t) => {
    const selectedCount = membersRows.filter(
      (item) => item.tier?.name === t.tier
    ).length;
    return {
      ...t,
      ...tierColors[t.tier],
      selectedCount,
    };
  });
}, [tierDistributionRaw, membersRows]);

const newTierInfo = tierDistribution.find((x) => x.tier === newTier);

// Adjust Points

const [openAdjustPoints, setOpenAdjustPoints] = useState(false);
const [expandedAdjustPoints, setExpandedAdjustPoints] = useState(null);
const [adjustPointsStep, setAdjustPointsStep] = useState("form"); 

const [adjustmentType, setAdjustmentType] = useState("add"); 
const [amountAdjustPoints, setAmountAdjustPoints] = useState(500);
const [reasonAdjustPoints, setReasonAdjustPoints] = useState("");
const [notesAdjustPoints, setNotesAdjustPoints] = useState("");


const handleAdjustPointsOpen = () => {
  handleClose();
  setOpenAdjustPoints(true);
};
const handleAdjustPointsClose = () => setOpenAdjustPoints(false);

const handleAdjustPointsFullClose = () => {
  setAdjustPointsStep("form");
  handleAdjustPointsClose();
};

const handlePreviewAdjustPointsImpact = () => {
  setAdjustPointsStep("preview");
};

const handleBackAdjustPointsToForm = () => {
  setAdjustPointsStep("form");
};

const handleConfirmAdjustPoints = () => {
  console.log({
    adjustmentType,
    amountAdjustPoints,
    reasonAdjustPoints,
    notesAdjustPoints,
    membersRows,
  });
  handleAdjustPointsFullClose();
};

const parsePoints = (val) => {
  if (typeof val === "number") return val;
  return Number(String(val).replace(/[^\d.-]/g, "")) || 0;
};

const totalSelectedMembersAdjustPoints = membersRows?.length || 0;

const totalPointsToBeAdjusted =
  parsePoints(amountAdjustPoints) * totalSelectedMembersAdjustPoints;

const adjustmentSignedAmount =
  adjustmentType === "add"
    ? parsePoints(amountAdjustPoints)
    : -parsePoints(amountAdjustPoints);

const isFormValid = reasonAdjustPoints && parsePoints(amountAdjustPoints) > 0;



// send notifications

const [openSendNotifications, setOpenSendNotifications] = useState(false);
const [expandedSendNotifications, setExpandedSendNotifications] = useState(null);
const [sendNotificationsStep, setSendNotificationsStep] = useState("form"); 

const [notificationType, setNotificationType] = useState("push"); 
const [notificationTitle, setNotificationTitle] = useState("");
const [notificationMessage, setNotificationMessage] = useState("");
const [ctaButton, setCtaButton] = useState("");
const [sendTime, setSendTime] = useState("now"); 
const [deliveryDate, setDeliveryDate] = useState("");
const [deliveryTime, setDeliveryTime] = useState("");
const [timeZone, setTimeZone] = useState("(UTC+02:00) Cairo");

const handleSendNotificationsOpen = () => {
  handleClose();
  setOpenSendNotifications(true);
};
const handleSendNotificationsClose = () => setOpenSendNotifications(false);

const handleSendNotificationsFullClose = () => {
  setSendNotificationsStep("form");
  handleSendNotificationsClose();
};

const handlePreviewSendNotifications = () => {
  setSendNotificationsStep("preview");
};

const handleBackSendNotificationsToForm = () => {
  setSendNotificationsStep("form");
};

const handleConfirmSendNotifications = () => {
  console.log({
    notificationType,
    notificationTitle,
    notificationMessage,
    ctaButton,
    sendTime,
    deliveryDate,
    deliveryTime,
    timeZone,
    membersRows,
  });
  handleSendNotificationsFullClose();
};

const totalSelectedMembersSendNotifications = membersRows?.length || 0;

const notificationTypeLabels = {
  push: "Push Notification",
  email: "Email",
  sms: "SMS",
};



const scheduledTimeLabel =
  sendTime === "schedule" && deliveryDate && deliveryTime
    ? `${deliveryDate} - ${deliveryTime} (${timeZone})`
    : null;

const titleMaxLength = 100;
const messageMaxLength = 500;


// Suspend membership

const [openSuspendMembership, setOpenSuspendMembership] = useState(false);
const [expandedSuspendMembership, setExpandedSuspendMembership] = useState(null);
const [suspendMembershipStep, setSuspendMembershipStep] = useState("form"); 

const [reasonSuspendMembership, setReasonSuspendMembership] = useState("");
const [suspensionDuration, setSuspensionDuration] = useState("Permanent"); 
const [customDurationDays, setCustomDurationDays] = useState("");
const [notifyMembersSuspend, setNotifyMembersSuspend] = useState(true);

const handleSuspendMembershipOpen = () => {
  handleClose();
  setOpenSuspendMembership(true);
};
const handleSuspendMembershipClose = () => setOpenSuspendMembership(false);

const handleSuspendMembershipFullClose = () => {
  setSuspendMembershipStep("form");
  handleSuspendMembershipClose();
};

const handlePreviewSuspendMembership = () => {
  setSuspendMembershipStep("preview");
};

const handleBackSuspendMembershipToForm = () => {
  setSuspendMembershipStep("form");
};

const handleConfirmSuspendMembership = () => {
  console.log({
    reasonSuspendMembership,
    suspensionDuration,
    customDurationDays,
    notifyMembersSuspend,
    membersRows,
  });
  handleSuspendMembershipFullClose();
};

const totalSelectedMembersSuspend = membersRows?.length || 0;

const durationLabel =
  suspensionDuration === "Custom"
    ? customDurationDays
      ? `${customDurationDays} days`
      : "Custom"
    : suspensionDuration;

const durationOptions = ["Permanent", "7 days", "30 days", "Custom"];

const isSuspendFormValid =
  reasonSuspendMembership &&
  (suspensionDuration !== "Custom" || Number(customDurationDays) > 0);

  return (
    <>
    {/* Suspend Membership */}
    
    <Modal
  show={openSuspendMembership}
  onHide={handleSuspendMembershipFullClose}
  dialogClassName="custom-modal-campaigns-width mt-0"
>
  <Modal.Body className="mx-1">
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"start"}
      borderBottom={"1px solid #D9D9D9"}
      py={2}
    >
      <Box>
        <Typography fontSize={14} fontWeight={600}>
          {suspendMembershipStep === "form"
            ? "Suspend Membership"
            : "Preview Suspension"}
        </Typography>
        <Typography color="#535353" fontSize={14} my={1}>
          {suspendMembershipStep === "form"
            ? "Temporarily or permanently suspend the selected members."
            : "Review the suspension details before confirming."}
        </Typography>
      </Box>
      <Box>
        <IconButton disableRipple onClick={handleSuspendMembershipFullClose}>
          <IoIosCloseCircle color="#535353" size={"30px"} />
        </IconButton>
      </Box>
    </Box>

    <Box>
      <Accordion
        expanded={expandedSuspendMembership === "1"}
        onChange={() =>
          setExpandedSuspendMembership(
            expandedSuspendMembership === "1" ? null : "1"
          )
        }
        sx={{
          my: 3,
          border: "none",
          outline: "none",
          "&:before": { display: "none" },
          "&.Mui-expanded": { boxShadow: "none" },
        }}
        className="shadow-sm"
      >
        <AccordionSummary
          sx={{ bgcolor: "#ECF9F7", py: 2 }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
          >
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  bgcolor: "#3FBEAC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <LuUsersRound color="#ffffff" size={25} />
              </Box>
              <Box>
                <Typography fontSize={14} color="#535353">
                  {suspendMembershipStep === "form"
                    ? "Selected Members"
                    : "Members to be suspended"}
                </Typography>
                <Typography fontSize={14} fontWeight={600}>
                  {totalSelectedMembersSuspend} members
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography fontSize={14}>View Members</Typography>
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          {membersRows.map((item, idx) => (
            <Box
              key={item.member?.phone || idx}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              my={2}
              p={0.5}
              width={"100%"}
            >
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Avatar src={item.member.img}></Avatar>
                <Box textAlign={"start"}>
                  <Typography fontSize={12}>{item.member.name}</Typography>
                  <Typography fontSize={12} color="#535353">
                    {item.member.phone}
                  </Typography>
                </Box>
              </Box>
              {suspendMembershipStep === "form" && (
                <IconButton disableRipple size="medium">
                  <IoIosRemoveCircle color="#A80101" />
                </IconButton>
              )}
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>

    {suspendMembershipStep === "form" && (
      <Box>
        <Typography fontSize={14} mb={1}>
          Reason
        </Typography>
        <TextField
          select
          fullWidth
          size="small"
          value={reasonSuspendMembership}
          onChange={(e) => setReasonSuspendMembership(e.target.value)}
          SelectProps={{
            displayEmpty: true,
            renderValue: (val) => val || "Select a reason",
          }}
        >
          <MenuItem value="Fraudulent Activity">Fraudulent Activity</MenuItem>
       
        </TextField>
        <Typography color="#535353" fontSize={12} my={1}>
          Choose a reason for this adjustment.
        </Typography>

        <Typography fontSize={14} mb={1} mt={2}>
          Suspension Duration
        </Typography>
        <Box display={"flex"} gap={1.5} mb={2} flexWrap={"wrap"}>
          {durationOptions.map((opt) => (
            <Button
              key={opt}
              onClick={() => setSuspensionDuration(opt)}
              sx={{
                textTransform: "capitalize",
                color: suspensionDuration === opt ? "#A80101" : "#000",
                width:"23%",
                px: 2.5,
                py: 1,
                border:
                  suspensionDuration === opt
                    ? "2px solid #A80101"
                    : "1px solid #D8D8D8",
                bgcolor: suspensionDuration === opt? "#FFF4F0" : "transparent",
                color: suspensionDuration === opt? "#000000" : "#535353",
                borderRadius: 2

              }}
            >
              {opt}
            </Button>
          ))}
        </Box>

        {suspensionDuration === "Custom" && (
          <TextField
            fullWidth
            size="small"
            type="number"
            placeholder="Number of days"
            value={customDurationDays}
            onChange={(e) => setCustomDurationDays(e.target.value)}
            InputProps={{
              endAdornment: (
                <Typography fontSize={12} color="#535353">
                  days
                </Typography>
              ),
            }}
            sx={{ mb: 2 }}
          />
        )}

        <Typography fontSize={14} mb={1} mt={1}>
          Notify Members
        </Typography>
        <Box display={"flex"} alignItems={"flex-start"} gap={1}>
          <Checkbox
            checked={notifyMembersSuspend}
            onChange={(e) => setNotifyMembersSuspend(e.target.checked)}
            size="small"
            sx={{
              p: 0,
              color: "#000000",
              "&.Mui-checked": { color: "#000000" },
            }}
          />
          <Box>
            <Typography fontSize={13}>
              Send notification email to suspended members
            </Typography>
            <Typography fontSize={11} color="#535353">
              Member will be notified about their suspension.
            </Typography>
          </Box>
        </Box>

    
          <Box 
          display={"flex"}
          gap={1.5}
          alignItems={"flex-start"}
          bgcolor={"#FFF4F0"}
          borderRadius={4}
          p={2}
          mt={2}>
               <Box
               display={"flex"} alignItems={"center"} gap={1}>
                    <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      bgcolor: "#A80101",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <IoWarningOutline color="#ffffff" size={25} />
                  </Box>
            
               </Box>
            
       <Box>
             <Typography fontSize={13} fontWeight={600} mb={0.5}>
              Suspended member will:
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
              <Typography component="li" fontSize={12} color="#000000">
                Cannot earn points
              </Typography>
              <Typography component="li" fontSize={12} color="#000000">
                Cannot redeem points
              </Typography>
              <Typography component="li" fontSize={12} color="#000000">
                Cannot receive rewards or offers
              </Typography>
              <Typography component="li" fontSize={12} color="#000000">
                Membership will be suspended until the duration ends
              </Typography>
       </Box>
            </Box>
          </Box>

        <Box display={"flex"} justifyContent={"space-between"} mt={3}>
          <Button
            sx={{ color: "#535353", textTransform: "capitalize" }}
            variant="text"
            onClick={handleSuspendMembershipFullClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={!isSuspendFormValid}
            sx={{
              bgcolor: "#A80101",
              "&:hover": { bgcolor: "#8a0101" },
              textTransform: "capitalize",
            }}
            onClick={handlePreviewSuspendMembership}
          >
            Preview Suspension
          </Button>
        </Box>
      </Box>
    )}

    {suspendMembershipStep === "preview" && (
      <Box>
        <Typography fontSize={14} fontWeight={600} mb={1}>
          Details
        </Typography>
       <Box border={"1px solid #E8E8E8"} borderRadius={3} p={2}>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Reason
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {reasonSuspendMembership}
          </Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Suspension Duration
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {durationLabel}
          </Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Notify Members
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {notifyMembersSuspend
              ? "Yes, send email notification"
              : "No, do not notify"}
          </Typography>
        </Box>
       
       </Box>

        <Typography fontSize={14} fontWeight={600} mt={3} mb={1}>
          Impact Summary
        </Typography>
          <Box 
          display={"flex"}
          gap={1.5}
          alignItems={"flex-start"}
          bgcolor={"#FFF4F0"}
          borderRadius={4}
          p={2}
          mt={2}>
               <Box
               display={"flex"} alignItems={"center"} gap={1}>
                    <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      bgcolor: "#A80101",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <IoWarningOutline color="#ffffff" size={25} />
                  </Box>
            
               </Box>
            
       <Box>
             <Typography fontSize={13} fontWeight={600} mb={0.5}>
              Suspended member will:
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
              <Typography component="li" fontSize={12} color="#000000">
                Cannot earn points
              </Typography>
              <Typography component="li" fontSize={12} color="#000000">
                Cannot redeem points
              </Typography>
              <Typography component="li" fontSize={12} color="#000000">
                Cannot receive rewards or offers
              </Typography>
              <Typography component="li" fontSize={12} color="#000000">
                Membership will be suspended until the duration ends
              </Typography>
       </Box>
            </Box>
          </Box>

        <Box display={"flex"} justifyContent={"space-between"} mt={4}>
          <Button
            sx={{ color: "#535353", textTransform: "capitalize" }}
            variant="text"
            onClick={handleBackSuspendMembershipToForm}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#A80101",
              "&:hover": { bgcolor: "#8a0101" },
              textTransform: "capitalize",
            }}
            onClick={handleConfirmSuspendMembership}
          >
            Confirm Suspension
          </Button>
        </Box>
      </Box>
    )}
  </Modal.Body>
</Modal>

  {/* Send Notification */}

<Modal
  show={openSendNotifications}
  onHide={handleSendNotificationsFullClose}
  dialogClassName="custom-modal-campaigns-width mt-0"
>
  <Modal.Body className="mx-1">
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"start"}
      borderBottom={"1px solid #D9D9D9"}
      py={2}
    >
      <Box>
        <Typography fontSize={14} fontWeight={600}>
          {sendNotificationsStep === "form"
            ? "Send Notifications"
            : "Preview Notifications"}
        </Typography>
        <Typography color="#535353" fontSize={14} my={1}>
          {sendNotificationsStep === "form"
            ? "Send a message or announcement to the selected members."
            : "Review your message before sending."}
        </Typography>
      </Box>
      <Box>
        <IconButton disableRipple onClick={handleSendNotificationsFullClose}>
          <IoIosCloseCircle color="#535353" size={"30px"} />
        </IconButton>
      </Box>
    </Box>

    <Box>
      <Accordion
        expanded={expandedSendNotifications === "1"}
        onChange={() =>
          setExpandedSendNotifications(
            expandedSendNotifications === "1" ? null : "1"
          )
        }
        sx={{
          my: 3,
          border: "none",
          outline: "none",
          "&:before": { display: "none" },
          "&.Mui-expanded": { boxShadow: "none" },
        }}
        className="shadow-sm"
      >
        <AccordionSummary
          sx={{ bgcolor: "#ECF9F7", py: 2 }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
          >
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  bgcolor: "#3FBEAC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <LuUsersRound color="#ffffff" size={25} />
              </Box>
              <Box>
                <Typography fontSize={14} color="#535353">
                  Selected Members
                </Typography>
                <Typography fontSize={14} fontWeight={600}>
                  {totalSelectedMembersSendNotifications} members
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography fontSize={14}>View Members</Typography>
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          {membersRows.map((item, idx) => (
            <Box
              key={item.member?.phone || idx}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              my={2}
              p={0.5}
              width={"100%"}
            >
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Avatar src={item.member.img}></Avatar>
                <Box textAlign={"start"}>
                  <Typography fontSize={12}>{item.member.name}</Typography>
                  <Typography fontSize={12} color="#535353">
                    {item.member.phone}
                  </Typography>
                </Box>
              </Box>
              {sendNotificationsStep === "form" && (
                <IconButton disableRipple size="medium">
                  <IoIosRemoveCircle color="#A80101" />
                </IconButton>
              )}
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>

    {sendNotificationsStep === "form" && (
      <Box>
        <Typography fontSize={14} mb={1}>
          Notification Type
        </Typography>
        <Box display={"flex"} gap={2} mb={2}>
          {[
            { key: "push", label: "Push Notification", icon: <MdOutlinePhoneAndroid /> },
            { key: "email", label: "Email", icon: <MdOutlineEmail /> },
            { key: "sms", label: "SMS", icon: <MdOutlineSms /> },
          ].map((opt) => (
            <Button
              key={opt.key}
              onClick={() => setNotificationType(opt.key)}
              startIcon={opt.icon}
              sx={{
                textTransform: "capitalize",
                width:"33%",
                color: "#000",
                gap:.5,
                px: 2,
                py: 1,
                borderRadius:2,
                border:
                  notificationType === opt.key
                    ? "1.5px solid #3FBEAC"
                    : "1px solid #D8D8D8",
                bgcolor:
                  notificationType === opt.key ? "#ECF9F7" : "transparent",
                  color: notificationType === opt.key ? "#000000" : "#535353"
              }}
            >
              {opt.label}
            </Button>
          ))}
        </Box>

        <Box display={"flex"} justifyContent={"space-between"} mb={0.5}>
          <Typography fontSize={14}>Title</Typography>
        </Box>
        <TextField
          fullWidth
          size="small"
          value={notificationTitle}
          onChange={(e) => {
            if (e.target.value.length <= titleMaxLength)
              setNotificationTitle(e.target.value);
          }}
        />
        <Typography fontSize={11} color="#535353" textAlign={"end"} my={0.5}>
          {notificationTitle.length} / {titleMaxLength}
        </Typography>

        <Typography fontSize={14} mb={0.5} mt={2}>
          Message
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={notificationMessage}
          onChange={(e) => {
            if (e.target.value.length <= messageMaxLength)
              setNotificationMessage(e.target.value);
          }}
        />
        <Typography fontSize={11} color="#535353" textAlign={"end"} my={0.5}>
          {notificationMessage.length} / {messageMaxLength}
        </Typography>

        <Typography fontSize={14} mb={1} mt={2}>
          CTA Button (optional)
        </Typography>
        <TextField
          select
          fullWidth
          size="small"
          value={ctaButton}
          onChange={(e) => setCtaButton(e.target.value)}
          SelectProps={{
            displayEmpty: true,
            renderValue: (val) => val || "Select a CTA button",
          }}
        >
          <MenuItem value="View Offers">View Offers</MenuItem>
      
        </TextField>

        <Typography fontSize={14} mb={1} mt={2}>
          Send Time
        </Typography>
        <Box display={"flex"} gap={3} mb={sendTime === "schedule" ? 2 : 0}>
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={0.5}
            sx={{ cursor: "pointer" }}
            onClick={() => setSendTime("now")}
          >
            <Radio
              checked={sendTime === "now"}
              size="small"
              sx={{ p: 0.5 }}
            />
            <Typography fontSize={13}>Send Now</Typography>
          </Box>
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={0.5}
            sx={{ cursor: "pointer" }}
            onClick={() => setSendTime("schedule")}
          >
            <Radio
              checked={sendTime === "schedule"}
              size="small"
              sx={{ p: 0.5 }}
            />
            <Typography fontSize={13}>Schedule for later</Typography>
          </Box>
        </Box>

        {sendTime === "schedule" && (
          <Box bgcolor={"#ECF9F799"} borderRadius={4} p={3} border={"1px solid #E8E8E8"}>
            <Box display={"flex"} gap={2} mb={2}>
              <Box flex={1}>
                <Typography fontSize={13} mb={0.5}>
                  Delivery Date
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  value={deliveryDate}
                  onChange={(e) => setDeliveryDate(e.target.value)}
                />
              </Box>
              <Box flex={1}>
                <Typography fontSize={13} mb={0.5}>
                  Delivery Time
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="time"
                  value={deliveryTime}
                  onChange={(e) => setDeliveryTime(e.target.value)}
                />
              </Box>
            </Box>
            <Typography fontSize={13} mb={0.5}>
              Time Zone
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={timeZone}
              onChange={(e) => setTimeZone(e.target.value)}
            >
              <MenuItem value="(UTC+02:00) Cairo">(UTC+02:00) Cairo</MenuItem>

            </TextField>
          </Box>
        )}

        <Box display={"flex"} justifyContent={"space-between"} mt={3}>
          <Button
            sx={{ color: "#535353", textTransform: "capitalize" }}
            variant="text"
            onClick={handleSendNotificationsFullClose}
          >
            Cancel
          </Button>
          <Box display={"flex"} gap={2}>
            <Button
              variant="outlined"
              sx={{
                color: "#000000",
                border: "1px solid #000",
                textTransform: "capitalize",
              }}
              onClick={handlePreviewSendNotifications}
            >
              Preview
            </Button>
            <Button
              variant="contained"
              sx={{
                bgcolor: "#000",
                "&:hover": { bgcolor: "#222" },
                textTransform: "capitalize",
              }}
              onClick={handleConfirmSendNotifications}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Box>
    )}

    {sendNotificationsStep === "preview" && (
      <Box>
        <Typography fontSize={14} fontWeight={600} mb={1}>
          Message Preview
        </Typography>
        <Box
          border={"4px solid #E8E8E8"}
          borderRadius={3}
          p={2}
          mb={3}
          bgcolor={"#FFFFFF"}
        >
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} mb={1}>
            <Box display={"flex"} alignItems={"center"} gap={1}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  bgcolor: "#000",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 700,
                  p:2
                }}
              >
                <img src={EstbnLogo} alt="" />
              </Box>
              <Typography fontSize={14} fontWeight={600}>
                ESTBN
              </Typography>
            </Box>
            <Typography fontSize={11} color="#535353">
              now
            </Typography>
          </Box>
          <Typography fontSize={14} fontWeight={600} mb={0.5}>
            {notificationTitle}
          </Typography>
          <Typography fontSize={12} color="#535353" mb={1.5}>
            {notificationMessage}
          </Typography>
          {ctaButton && (
            <Button
              fullWidth
              variant="contained"
              sx={{
                bgcolor: "#000",
                "&:hover": { bgcolor: "#222" },
                textTransform: "capitalize",
              }}
            >
              {ctaButton}
            </Button>
          )}
        </Box>

        <Typography fontSize={14} fontWeight={600} mb={1}>
          Details
        </Typography>
     <Box border={"1px solid #E8E8E8"} borderRadius={3} p={1}>
         <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Notification Type
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {notificationTypeLabels[notificationType]}
          </Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Title
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {notificationTitle}
          </Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Message
          </Typography>
          <Typography fontSize={13} fontWeight={600} textAlign={"end"} maxWidth={"60%"}>
            {notificationMessage}
          </Typography>
        </Box>
          {ctaButton && (
          <Box display={"flex"} justifyContent={"space-between"} py={1}>
            <Typography fontSize={13} color="#535353">
              CTA Button
            </Typography>
            <Typography fontSize={13} fontWeight={600}>
              {ctaButton}
            </Typography>
          </Box>
        )}
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            {sendTime === "now" ? "Send Time" : "Scheduled Time"}
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {sendTime === "now" ? "Send Now" : scheduledTimeLabel || "-"}
          </Typography>
        </Box>
     </Box>
      

        <Box display={"flex"} justifyContent={"space-between"} mt={4}>
          <Button
            sx={{ color: "#535353", textTransform: "capitalize" }}
            variant="text"
            onClick={handleBackSendNotificationsToForm}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#000",
              "&:hover": { bgcolor: "#222" },
              textTransform: "capitalize",
            }}
            onClick={handleConfirmSendNotifications}
          >
            {sendTime === "now" ? "Send Notification" : "Scheduled Notification"}
          </Button>
        </Box>
      </Box>
    )}
  </Modal.Body>
</Modal>

{/* Adjust Points */}

    <Modal
  show={openAdjustPoints}
  onHide={handleAdjustPointsFullClose}
  dialogClassName="custom-modal-campaigns-width mt-0"
>
  <Modal.Body className="mx-1">
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"start"}
      borderBottom={"1px solid #D9D9D9"}
      py={2}
    >
      <Box>
        <Typography fontSize={14} fontWeight={600}>
          {adjustPointsStep === "form" ? "Adjust Points" : "Preview Adjustment"}
        </Typography>
        <Typography color="#535353" fontSize={14} my={1}>
          {adjustPointsStep === "form"
            ? "Add or deduct points for the selected members."
            : "Review the impact before applying the adjustment."}
        </Typography>
      </Box>
      <Box>
        <IconButton disableRipple onClick={handleAdjustPointsFullClose}>
          <IoIosCloseCircle color="#535353" size={"30px"} />
        </IconButton>
      </Box>
    </Box>

    <Box>
      <Accordion
        expanded={expandedAdjustPoints === "1"}
        onChange={() =>
          setExpandedAdjustPoints(expandedAdjustPoints === "1" ? null : "1")
        }
        sx={{
          my: 3,
          border: "none",
          outline: "none",
          "&:before": { display: "none" },
          "&.Mui-expanded": { boxShadow: "none" },
        }}
        className="shadow-sm"
      >
        <AccordionSummary
          sx={{ bgcolor: "#ECF9F7", py: 2 }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
          >
            <Box display={"flex"} alignItems={"center"} gap={2}>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  bgcolor: "#3FBEAC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <LuUsersRound color="#ffffff" size={25} />
              </Box>
              <Box>
                <Typography fontSize={14} color="#535353">
                  Selected Members
                </Typography>
                <Typography fontSize={14} fontWeight={600}>
                  {totalSelectedMembersAdjustPoints} members
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography fontSize={14}>View Members</Typography>
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          {membersRows.map((item, idx) => (
            <Box
              key={item.member?.phone || idx}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              my={2}
              p={0.5}
              width={"100%"}
            >
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Avatar src={item.member.img}></Avatar>
                <Box textAlign={"start"}>
                  <Typography fontSize={12}>{item.member.name}</Typography>
                  <Typography fontSize={12} color="#535353">
                    {item.member.phone}
                  </Typography>
                </Box>
              </Box>
              {adjustPointsStep === "form" && (
                <IconButton disableRipple size="medium">
                  <IoIosRemoveCircle color="#A80101" />
                </IconButton>
              )}
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>

    {adjustPointsStep === "form" && (
      <Box>
        <Typography fontSize={14} mb={1}>
          Adjustment Type
        </Typography>
        <Grid container spacing={1.5} mb={2}>
          <Grid item xs={6}>
            <Button
              fullWidth
              onClick={() => setAdjustmentType("add")}
              startIcon={<FaPlusCircle color="#3FBEAC" />}
              sx={{
                gap:1,
                alignItems:"center",
                justifyContent: "flex-start",
                textTransform: "capitalize",
                color: "#000",
                py: 1,
                border:
                  adjustmentType === "add"
                    ? "1.5px solid #3FBEAC"
                    : "1px solid #E0E0E0",
                bgcolor: adjustmentType === "add" ? "#ECF9F7" : "transparent",
                
              }}
            >
              Add Points
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              onClick={() => setAdjustmentType("deduct")}
              startIcon={<FaMinusCircle color="#A80101" />}
              sx={{
                gap:1,
                alignItems:"center",
                justifyContent: "flex-start",
                textTransform: "capitalize",
                color: "#000",
                py: 1,
                border:
                  adjustmentType === "deduct"
                    ? "1.5px solid #A80101"
                    : "1px solid #E0E0E0",
                bgcolor:
                  adjustmentType === "deduct" ? "#FDECEC" : "transparent",
              }}
            >
              Deduct Points
            </Button>
          </Grid>
        </Grid>

        <Typography fontSize={14} mb={1}>
          Amount
        </Typography>
        <TextField
          fullWidth
          size="small"
          type="number"
          value={amountAdjustPoints}
          onChange={(e) => setAmountAdjustPoints(e.target.value)}
          InputProps={{
            // startAdornment: (
            //   <IconButton
            //     size="small"
            //     disableRipple
            //     onClick={() =>
            //       setAmountAdjustPoints((prev) => parsePoints(prev) + 1)
            //     }
            //   >
            //     <AiOutlinePlus size={14} />
            //   </IconButton>
            // ),
            endAdornment: (
              <Typography fontSize={12} color="#535353">
                pts
              </Typography>
            ),
          }}
        />
        <Typography color="#535353" fontSize={12} my={1}>
          Enter the number of points to add to each selected member.
        </Typography>

        <Typography fontSize={14} mb={1} mt={2}>
          Reason
        </Typography>
        <TextField
          select
          fullWidth
          size="small"
          value={reasonAdjustPoints}
          onChange={(e) => setReasonAdjustPoints(e.target.value)}
          SelectProps={{
            displayEmpty: true,
            renderValue: (val) => val || "Select Reason",
          }}
        >
          <MenuItem value="Marketing Campaign">Marketing Campaign</MenuItem>
 
        </TextField>
        <Typography color="#535353" fontSize={12} my={1}>
          Choose a reason for this adjustment.
        </Typography>

        <Typography fontSize={14} mb={1} mt={2}>
          Notes (optional)
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="Add a note..."
          value={notesAdjustPoints}
          onChange={(e) => {
            if (e.target.value.length <= 200) setNotesAdjustPoints(e.target.value);
          }}
        />
        <Typography fontSize={11} color="#535353" textAlign={"end"} my={0.5}>
          {notesAdjustPoints.length} / 200
        </Typography>

        <Box display={"flex"} justifyContent={"space-between"} mt={3}>
          <Button
            sx={{ color: "#535353", textTransform: "capitalize" }}
            variant="text"
            onClick={handleAdjustPointsFullClose}
          >
            Cancel
          </Button>
          <Box display={"flex"} gap={2}>
            <Button
              variant="outlined"
              sx={{
                color: "#000000",
                border: "1px solid #000",
                textTransform: "capitalize",
              }}
              onClick={handlePreviewAdjustPointsImpact}
            >
              Preview Impact
            </Button>
            <Button
              variant="contained"
              disabled={!isFormValid}
              sx={{
                bgcolor: "#000",
                "&:hover": { bgcolor: "#222" },
                textTransform: "capitalize",
              }}
              onClick={handleConfirmAdjustPoints}
            >
              {adjustmentType === "add" ? "Add Points" : "Deduct Points"}
            </Button>
          </Box>
        </Box>
      </Box>
    )}

    {adjustPointsStep === "preview" && (
      <Box px={1}>
        <Grid container spacing={2} my={2} border={"1px solid #E0E0E0"} borderRadius={2} textAlign={"center"} p={1.5}>
          <Grid item xs={6} sx={{ borderRight: {
                    xs: "none",
                    md: "1px solid #D9D9D9",
                },}}>
            <Box textAlign={"center"}>
              <Box display={"flex"} alignItems={"center"} justifyContent={"flex-start"} gap={1} mb={0.5} >
                {adjustmentType === "add" ? (
                  <FaPlusCircle color="#3FBEAC" size={20} />
                ) : (
                  <FaMinusCircle color="#A80101" />
                )}
             <Box>
                <Typography fontSize={12} color="#535353">
                  Adjustment Type
                </Typography>
                    <Typography fontSize={14}>
                {adjustmentType === "add" ? "Add Points" : "Deduct Points"}
              </Typography>
             </Box>
              </Box>
          
            </Box>
          </Grid>
          <Grid item xs={6} >
            <Box textAlign={"center"}>
              <Typography fontSize={12} color="#535353" mb={0.5}>
                Points Per Member
              </Typography>
              <Typography fontSize={14} fontWeight={600}>
                {adjustmentType === "add" ? "+" : "-"}
                {parsePoints(amountAdjustPoints)} pts
              </Typography>
            </Box>
          </Grid>
       
      
        </Grid>

   <Grid container spacing={2} my={2} border={"1px solid #E0E0E0"} borderRadius={2} p={1.5}>
                <Grid item xs={6}  sx={{ borderRight: {
                    xs: "none",
                    md: "1px solid #D9D9D9",
                },}}>
            <Box textAlign={"center"}>
              <Box display={"flex"} alignItems={"center"} gap={1} mb={0.5}>
                    <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      bgcolor: "#F6E9FC",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <LuUsersRound color="#7E1BAD" size={25} />
                  </Box>
                  <Box>
                <Typography fontSize={12} color="#535353">
                  Total Members
                </Typography>
              <Typography fontSize={14} fontWeight={600}>
                {totalSelectedMembersAdjustPoints} members
              </Typography>
  
                  </Box>
              </Box>
             
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box>
           
              <Box display={"flex"} alignItems={"center"} justifyContent={"center"} gap={1} mb={0.5}>
                                 <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      bgcolor: "#FFFAEA",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <FaRegStar size={20} color="#FEB91E" />
                  </Box>
              <Box>
                    <Typography fontSize={12} color="#535353">
                  Total Points To Be Added
                </Typography>
          <Typography fontSize={14} fontWeight={600}>
                {totalPointsToBeAdjusted.toLocaleString()} pts{" "}
                <Typography component="span" fontSize={11} color="#535353">
                  ({parsePoints(amountAdjustPoints)} x{" "}
                  {totalSelectedMembersAdjustPoints} members)
                </Typography>
              </Typography>
              </Box>
              </Box>
           
            
            </Box>
          </Grid>
          </Grid>

        <Typography fontSize={14}  mb={1}>
          Member Affected
        </Typography>
        <Box border={"1px solid #E0E0E0"} borderRadius={2} overflow="hidden" mb={3} p={1.5} >
     
          <Grid container spacing={2} p={1} borderBottom={"1px solid #E8E8E8"} >
          <Grid item xs={4}>
   <Typography fontSize={12} color="#535353">
              Member
            </Typography>
          </Grid>
          <Grid item xs={2.5}>
             <Typography fontSize={12} color="#535353" textAlign={"center"}>
              Current Balance
            </Typography>
          </Grid>
          <Grid item xs={2.5}>
            <Typography fontSize={12} color="#535353"  textAlign={"center"}>
              Adjustment
            </Typography>
          </Grid>
          <Grid item xs={2.5}>
            <Typography fontSize={12} color="#535353" textAlign={"end"}>
              New Balance
            </Typography>
          </Grid>
          </Grid>
         
         
          
          

          {membersRows.map((item, idx) => {
            const currentBalance = parsePoints(item.points_balance);
            const newBalance = currentBalance + adjustmentSignedAmount;
            return (
 <Grid container key={item.member?.phone || idx} spacing={2} alignItems={"center"}  p={1} borderBottom={idx < membersRows.length - 1 ? "1px solid #E8E8E8" : "none"}>
          <Grid item xs={4}>
              <Box display={"flex"} alignItems={"center"}  gap={1}>
                  <Avatar src={item.member.img} sx={{ width: 28, height: 28 }} />
                  <Box textAlign={"start"}>
                    <Typography fontSize={12}>{item.member.name}</Typography>
                    <Typography fontSize={11} color="#535353">
                      {item.member.phone}
                    </Typography>
                  </Box>
                </Box> 
                </Grid>
          <Grid item xs={2.5}>
             <Typography fontSize={13}  textAlign={"center"}>
                  {currentBalance.toLocaleString()} pts
                </Typography>
          </Grid>
          <Grid item xs={2.5}>
              <Typography
                  fontSize={13}
                  textAlign={"center"}
                  color={adjustmentType === "add" ? "#3FBEAC" : "#A80101"}
                >
                  {adjustmentType === "add" ? "+" : "-"}
                  {parsePoints(amountAdjustPoints)} pts
                </Typography>
          </Grid>
          <Grid item xs={2.5}>
            <Typography fontSize={13}  textAlign={"end"} fontWeight={600}>
                  {newBalance.toLocaleString()} pts
                </Typography>
          
          </Grid>
          
          
          </Grid>

         
            );
          })}
        </Box>

        <Typography fontSize={14} fontWeight={600} mb={1}>
          Details
        </Typography>
   <Box border={"1px solid #E8E8E8"} borderRadius={3} p={1}>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Reason
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {reasonAdjustPoints}
          </Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Notes
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {notesAdjustPoints || "-"}
          </Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} py={1}>
          <Typography fontSize={13} color="#535353">
            Adjustment Date
          </Typography>
          <Typography fontSize={13} fontWeight={600}>
            {dayjs().format("MMM D, YYYY - h:mm A")}
          </Typography>
        </Box>
   
   </Box>

        <Box display={"flex"} justifyContent={"space-between"} mt={4}>
          <Button
            sx={{ color: "#535353", textTransform: "capitalize" }}
            variant="text"
            onClick={handleBackAdjustPointsToForm}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#000",
              "&:hover": { bgcolor: "#222" },
              textTransform: "capitalize",
            }}
            onClick={handleConfirmAdjustPoints}
          >
            Confirm & {adjustmentType === "add" ? "Add" : "Deduct"} Points
          </Button>
        </Box>
      </Box>
    )}
  </Modal.Body>
</Modal>


{/* Change Tier */}

         <Modal
      show={openChangeTier}
      onHide={handleChangeTierFullClose}
      dialogClassName="custom-modal-campaigns-width mt-0"
    >
      <Modal.Body className="mx-1">
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"start"}
          borderBottom={"1px solid #D9D9D9"}
          py={2}
        >
          <Box>
            <Typography fontSize={14} fontWeight={600}>
              {tierStep === "form" ? "Change Tier" : "Preview Change Tier"}
            </Typography>
            <Typography color="#535353" fontSize={14} my={1}>
              {tierStep === "form"
                ? "Change the loyalty tier for the selected members."
                : "Review the impact before applying the changes."}
            </Typography>
          </Box>
          <Box>
            <IconButton disableRipple onClick={handleChangeTierFullClose}>
              <IoIosCloseCircle color="#535353" size={"30px"} />
            </IconButton>
          </Box>
        </Box>

        <Box>
          <Accordion
            expanded={expandedChangeTier === "1"}
            onChange={() =>
              setExpandedChangeTier(expandedChangeTier === "1" ? null : "1")
            }
            sx={{
              my: 3,
              border: "none",
              outline: "none",
              "&:before": { display: "none" },
              "&.Mui-expanded": { boxShadow: "none" },
            }}
            className="shadow-sm"
          >
            <AccordionSummary
              sx={{ bgcolor: "#ECF9F7", py: 2 }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={"100%"}
              >
                <Box display={"flex"} alignItems={"center"} gap={2}>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      bgcolor: "#3FBEAC",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <LuUsersRound color="#ffffff" size={25} />
                  </Box>
                  <Box>
                    <Typography fontSize={14} color="#535353">
                      Selected Members
                    </Typography>
                    <Typography fontSize={14} fontWeight={600}>
                      {totalSelectedMembersChangeTier} members
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography fontSize={14}>View Members</Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              {membersRows.map((item, idx) => (
                <Box
                  key={item.member?.phone || idx}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  my={2}
                  p={0.5}
                  width={"100%"}
                >
                  <Box display={"flex"} alignItems={"center"} gap={2}>
                    <Avatar src={item.member.img}></Avatar>
                    <Box textAlign={"start"}>
                      <Typography fontSize={12}>{item.member.name}</Typography>
                      <Typography fontSize={12} color="#535353">
                        {item.member.phone}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        </Box>

        {tierStep === "form" && (
          <Box>
            <Typography fontSize={14} fontWeight={600} mb={2}>
              Current Tier Distribution
            </Typography>
            <Grid container spacing={1.5} mb={3}>
              {tierDistribution.map((t) => {
                return (
                  <Grid item xs={3} key={t.tier}>
                    <Box
                      sx={{
                        bgcolor: t.bgcolor,
                        borderRadius: 2,
                        p: 2,
                      }}
                    >
                      <Typography fontSize={14}  fontWeight={600}>
                        {t.tier}
                      </Typography>
                      <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1}>
                         <Typography fontSize={16} fontWeight={700} >
                        {t.count.toLocaleString()}
                      </Typography>
                      <Typography fontSize={11} >
                        {t.percent}
                      </Typography>
                      </Box>
                     
                    </Box>
                  </Grid>
                );
              })}
            </Grid>

            <Typography fontSize={14} mb={1}>
              Change Tier To
            </Typography>
         <TextField
  select
  fullWidth
  size="small"
  value={newTier}
  onChange={(e) => setNewTier(e.target.value)}
  SelectProps={{
    displayEmpty: true,
    renderValue: (val) => val || "Select new tier",
  }}
>
  {Object.keys(tierColors).map((tierName) => (
    <MenuItem key={tierName} value={tierName}>
      {tierName}
    </MenuItem>
  ))}
</TextField>
            <Typography fontSize={14} mb={1} mt={2}>
              Reason
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={reasonChangeTier}
              onChange={(e) => setReasonChangeTier(e.target.value)}
              SelectProps={{
                displayEmpty: true,
                renderValue: (val) => val || "Select reason",
              }}
            >
              <MenuItem value="Marketing Campaign">Marketing Campaign</MenuItem>
          
            </TextField>
            <Typography color="#535353" fontSize={12} my={1}>
              Choose a reason for changing tier.
            </Typography>

            <Typography fontSize={14} mb={1} mt={2}>
              Notes (optional)
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              placeholder="Add a note..."
              value={notesChangeTier}
              onChange={(e) => {
                if (e.target.value.length <= 200) setNotesChangeTier(e.target.value);
              }}
            />
            <Typography
              fontSize={11}
              color="#535353"
              textAlign={"end"}
              my={0.5}
            >
              {notesChangeTier.length} / 200
            </Typography>

            <Box display={"flex"} justifyContent={"space-between"} mt={3}>
              <Button sx={{color:"#535353", textTransform:"capitalize"}} variant="text" onClick={handleChangeTierFullClose}>
                Cancel
              </Button>
              <Box display={"flex"} gap={2}>
                <Button variant="outlined" sx={{color:"#000000", border:"1px solid #000", textTransform:"capitalize"}} onClick={handlePreviewChangeTierImpact}>
                  Preview Impact
                </Button>
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#000", "&:hover": { bgcolor: "#222" } , textTransform:"capitalize"}}
                  onClick={handleConfirmChangeTier}
                >
                  Change Tier
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        {tierStep === "preview" && (
          <Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            border={"1px solid #E8E8E8"}
              borderRadius={2}
              p={2}
              mb={3}
            >
                <Box
               display={"flex"} alignItems={"center"} gap={1}>
                    <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      bgcolor: "#F6E9FC",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <LuUsersRound color="#7E1BAD" size={25} />
                  </Box>
              <Box>
                <Typography fontSize={12} color="#535353">
                  Current Distribution
                </Typography>
                <Typography fontSize={13} fontWeight={600}>
                  {totalSelectedMembersChangeTier} members
                </Typography>
              </Box>
               </Box>
            
              <BsArrowRight size={25}/>
            <Box display={"flex"} alignItems={"center"} gap={2}>
  <FaRegStar size={25} color={newTierInfo?.dot} />
  <Box>
    <Typography fontSize={14} color="#535353">
      New Tier
    </Typography>
    <Box
      display={"inline-flex"}
      alignItems={"center"}
      gap={0.5}
      bgcolor={newTierInfo?.bgcolor}
      px={1.2}
      py={0.3}
      borderRadius={5}
      mt={0.3}
    >
      <Typography fontSize={12} fontWeight={600} color={newTierInfo?.dot}>
        {newTier}
      </Typography>
    </Box>
  </Box>
</Box>
            </Box>

            <Typography fontSize={14} fontWeight={600} mb={1}>
              Current Tier To New Tire Impact
            </Typography>
          <Box border={"1px solid #E0E0E0"} borderRadius={2} overflow="hidden" mb={3}>
            
        <Grid container spacing={2} p={2} borderBottom={"1px solid #E8E8E8"}>
            <Grid item xs={12} md={3}>
                <Typography fontSize={12} color="#535353" >
      Current Tier
    </Typography>
            </Grid>
            <Grid item xs={12} md={3}>
                  <Typography fontSize={12} color="#535353"  textAlign={"center"}>
      Members
    </Typography>
            </Grid>
            <Grid item xs={12} md={3}>{""}</Grid>
            <Grid item xs={12} md={3}>
                 <Typography fontSize={12} color="#535353" textAlign={"end"}>
      Will Change To
    </Typography>
            </Grid>

            </Grid>
  

  {tierDistribution
    .filter((t) => t.selectedCount > 0)
    .map((t,i) => (


        <Grid container spacing={2} px={2} py={1} borderBottom= {i < tierDistribution.length - 1 ? "1px solid #E8E8E8" : "none"}>
            <Grid item xs={12} md={3}>
                   <Box display={"flex"} alignItems={"center"} gap={1} >
          <Box width={8} height={8} borderRadius={"50%"} bgcolor={t.dot} />
          <Typography fontSize={13}>{t.tier}</Typography>
        </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                <Box>
          <Typography fontSize={13} textAlign={"center"}>
          {t.selectedCount}
        </Typography>
      </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                  <Box textAlign={"center"} >
              <BsArrowRight size={25}/>
        </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                 <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          gap={1}

        >
          
          <Box display={"flex"} alignItems={"center"} gap={0.5}>
            <Box width={8} height={8} borderRadius={"50%"} bgcolor={newTierInfo?.dot} />
            <Typography fontSize={13}>{newTier}</Typography>
          </Box>
        </Box>
            </Grid>
        </Grid>

    ))}
</Box>

            <Typography fontSize={14} fontWeight={600} mb={1}>
              Details
            </Typography>
        <Box border={"1px solid #E8E8E8"} borderRadius={3} p={1.5}>
                <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                New Tier
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {newTier}
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Reason
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {reasonChangeTier}
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Notes
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {notesChangeTier || "-"}
              </Typography>
            </Box>
        </Box>

            <Box display={"flex"} justifyContent={"space-between"} mt={4}>
              <Button sx={{color:"#535353", textTransform:"capitalize"}} variant="text"  onClick={handleBackChangeTierToForm}>
                Back
              </Button>
              <Button
                variant="contained"
                sx={{ bgcolor: "#000", "&:hover": { bgcolor: "#222" }, textTransform:"capitalize" }}
                onClick={handleConfirmChangeTier}
              >
                Confirm & Change Tier
              </Button>
            </Box>
          </Box>
        )}
      </Modal.Body>
    </Modal>

    {/* Add Bonus Points */}
      <Modal
      show={openAddBonusPoints}
      onHide={handleFullClose}
      dialogClassName="custom-modal-campaigns-width mt-0"
    >
      <Modal.Body className="mx-1">
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"start"}
          borderBottom={"1px solid #D9D9D9"}
          py={2}
        >
          <Box>
            <Typography fontSize={14} fontWeight={600}>
              {bonusStep === "form" ? "Add Bonus Points" : "Preview Bonus Points"}
            </Typography>
            <Typography color="#535353" fontSize={14} my={1}>
              {bonusStep === "form"
                ? "Add bonus points to the selected members."
                : "Preview the impact before adding bonus points."}
            </Typography>
          </Box>
          <Box>
            <IconButton disableRipple onClick={handleFullClose}>
              <IoIosCloseCircle color="#535353" size={"30px"} />
            </IconButton>
          </Box>
        </Box>

        <Box>
          <Accordion
            expanded={expandedPoints === "1"}
            onChange={() =>
              setExpandedPoints(expandedPoints === "1" ? null : "1")
            }
            sx={{
              my: 3,
              border: "none",
              outline: "none",
              "&:before": { display: "none" },
              "&.Mui-expanded": { boxShadow: "none" },
            }}
            className="shadow-sm"
          >
            <AccordionSummary
              sx={{ bgcolor: "#ECF9F7", py: 2 }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={"100%"}
              >
                <Box display={"flex"} alignItems={"center"} gap={2}>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      bgcolor: "#3FBEAC",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <LuUsersRound color="#ffffff" size={25} />
                  </Box>
                  <Box>
                    <Typography fontSize={14} color="#535353">
                      Selected Members
                    </Typography>
                    <Typography fontSize={14} fontWeight={600}>
                      {totalSelectedMembers} members
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography fontSize={14}>View Members</Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              {membersRows.map((item, idx) => (
                <Box
                  key={item.member?.phone || idx}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  my={2}
                  p={0.5}
                  width={"100%"}
                >
                  <Box display={"flex"} alignItems={"center"} gap={2}>
                    <Avatar src={item.member.img}></Avatar>
                    <Box textAlign={"start"}>
                      <Typography fontSize={12}>{item.member.name}</Typography>
                      <Typography fontSize={12} color="#535353">
                        {item.member.phone}
                      </Typography>
                    </Box>
                  </Box>
                  {bonusStep === "form" && (
                    <Box display={"flex"}>
                      <IconButton disableRipple size="medium">
                        <IoIosRemoveCircle color="#A80101" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        </Box>

        {bonusStep === "form" && (
          <Box>
            <Typography fontSize={14} mb={1}>
              Bonus Points
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="number"
              value={bonusPoints}
              onChange={(e) => setBonusPoints(e.target.value)}
              InputProps={{
                endAdornment: (
                  <Typography fontSize={12} color="#535353">
                    pts
                  </Typography>
                ),
              }}
            />
            <Typography color="#535353" fontSize={12} my={1}>
              Enter the amount of bonus points to add to each selected member.
            </Typography>

            <Typography fontSize={14} mb={1} mt={2}>
              Reason
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              
            >
              <MenuItem  value="Marketing Campaign">Marketing Campaign</MenuItem>
           
            </TextField>
            <Typography color="#535353" fontSize={12} my={1}>
              Choose a reason for adding bonus points.
            </Typography>

            <Typography fontSize={14} mb={1} mt={2}>
              Expiration
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={expiration}
              onChange={(e) => setExpiration(e.target.value)}
            >
              <MenuItem value="No Expiration">No Expiration</MenuItem>
              <MenuItem value="30 Days">30 Days</MenuItem>
              <MenuItem value="90 Days">90 Days</MenuItem>
            </TextField>
            <Typography color="#535353" fontSize={12} my={1}>
              Bonus Points will never expire.
            </Typography>
             <Typography fontSize={14} mb={1} mt={2}>
              Notes (optional)
            </Typography>
                 <textarea
                 style={{border:"1px solid #E8E8E8"}}
                                className="form-control mb-3"
                                rows={3}
                                placeholder="Add a note ..."
                                onChange={(e) => setNotes(e.target.value)}

                            />

            <Box display={"flex"} justifyContent={"space-between"} mt={3}>
              <Button sx={{color:"#535353", textTransform:"capitalize"}} variant="text" onClick={handleFullClose}>
                Cancel
              </Button>
              <Box display={"flex"} gap={2}>
                <Button variant="outlined" sx={{color:"#000000", border:"1px solid #000", textTransform:"capitalize"}} onClick={handlePreviewImpact}>
                  Preview Impact
                </Button>
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#000", "&:hover": { bgcolor: "#222" }, textTransform:"capitalize" }}
                  onClick={handleConfirmAddPoints}
                >
                  Add Points
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        {bonusStep === "preview" && (
          <Box>
            <Typography fontSize={14} fontWeight={600} mb={1}>
              Bonus Summary
            </Typography>
             <Box border={"1px solid #E8E8E8"} borderRadius={2} p={1}>
                       <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Bonus Points Per Member
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {bonusPoints} pts
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} py={1} borderBottom={"1px solid #D9D9D9"}>
              <Typography fontSize={13} color="#535353">
                Total Selected Members
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {totalSelectedMembers}
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Total Points To Be Added
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {totalPointsToBeAdded} pts
              </Typography>
            </Box>
             </Box>

            <Typography fontSize={14} fontWeight={600} mt={3} mb={1}>
              Details
            </Typography>
      <Box border={"1px solid #E8E8E8"} borderRadius={2} p={1}>
              <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Reason
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {reason}
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Expiration
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {expiration}
              </Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} py={1}>
              <Typography fontSize={13} color="#535353">
                Notes
              </Typography>
              <Typography fontSize={13} fontWeight={600}>
                {notes || "-"}
              </Typography>
            </Box>
      </Box>

            <Box display={"flex"} justifyContent={"space-between"} mt={4}>
              <Button sx={{color:"#535353", textTransform:"capitalize"}} variant="text" onClick={handleBackToForm}>
                Back
              </Button>
              <Button
                variant="contained"
                sx={{ bgcolor: "#000", "&:hover": { bgcolor: "#222" } }}
                onClick={handleConfirmAddPoints}
              >
                Confirm & Add Points
              </Button>
            </Box>
          </Box>
        )}
      </Modal.Body>
    </Modal>

    {/* Client Profile */}
     <Modal show={openClientProfile} onHide={handleClientProfileClose}  dialogClassName='custom-modal-campaigns-width mt-0' >
                    
                    <Modal.Body className='mx-1'>
                        <Box display={"flex"} justifyContent={"end"}>
                          <IconButton disableRipple onClick={handleClientProfileClose}>
                           <IoIosCloseCircle color='#535353' size={"30px"}/></IconButton>
                        </Box>
                     <Box display={"flex"} alignItems={"start"} gap={2} borderBottom={"1px solid #D9D9D9"} pb={2}>
                        <Avatar sx={{width:"80px", height:"80px"}} src={memberDetails.img}></Avatar>
                        <Box>
                            <Box>
                                <Box display={"flex"} alignItems={"start"} gap={2}>
                                    <Typography fontSize={16} fontWeight={600}>{memberDetails.name}</Typography>
                                     <Chip size='small' label={memberDetails.tier.name} sx={{bgcolor: memberDetails.tier.bgColor, px:3, py:1}}/>
                                </Box>
                            
                            {memberDetails.info.map((item)=>
                            <Box display={"flex"} alignItems={"center"} gap={2}>
                            <Box>{item.icon}</Box>
                            <Typography fontSize={14} color='#535353'>{item.label}</Typography>
                            </Box>
                            )}
                            </Box>
                           
                        </Box>
                        <Box></Box>
                     </Box>
                    <Box borderBottom={"1px solid #D9D9D9"} pb={2} my={1}>
                         <Box mt={2} mb={1}>
                        <Typography fontWeight={600}>Points Summary</Typography>
                     </Box>
                     <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} >
                        <Box textAlign={"center"}>
                            <Typography fontSize={14} color='#535353'>Points Balance</Typography>
                            <Typography fontSize={14} fontWeight={600} my={1}>12,850 pts</Typography>
                        </Box>
                        <Box textAlign={"center"}>
                            <Typography fontSize={14} color='#535353'>Points Earned</Typography>
                            <Typography fontSize={14} fontWeight={600} my={1}>12,850 pts</Typography>
                        </Box>
                        <Box textAlign={"center"}>
                            <Typography fontSize={14} color='#535353'>Points Redeemed</Typography>
                            <Typography fontSize={14} fontWeight={600} my={1}>12,850 pts</Typography>
                        </Box>
                        <Box textAlign={"center"}>
                            <Typography fontSize={14} color='#535353'>Points Expired</Typography>
                            <Typography fontSize={14} fontWeight={600} my={1}  color='#A80101'>12,850 pts</Typography>
                        </Box>
                     </Box>
                    </Box>
                    <Box my={2} py={1} borderBottom={"1px solid #D9D9D9"}>
                        <Typography fontWeight={600}>Member Details</Typography>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                    <Typography color='#535353' fontWeight={400} fontSize={14}>Last Active</Typography>
                    <Typography fontSize={14}>{memberDetails.last_active}</Typography>
                
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                    <Typography color='#535353' fontWeight={400} fontSize={14}>Total Orders</Typography>
                    <Typography fontSize={14}>{memberDetails.total_order}</Typography>
                
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                    <Typography color='#535353' fontWeight={400} fontSize={14}>Total Spent</Typography>
                    <Typography fontSize={14}>{memberDetails.total_spend}</Typography>
                
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                    <Typography color='#535353' fontWeight={400} fontSize={14}>Avg. Order Value</Typography>
                    <Typography fontSize={14}>{memberDetails.avg_order_value}</Typography>
                
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                    <Typography color='#535353' fontWeight={400} fontSize={14}>Member Since</Typography>
                    <Typography fontSize={14}>{memberDetails.member_since}</Typography>
                
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                    <Typography color='#535353' fontWeight={400} fontSize={14}>Referral Code</Typography>
                    <Box display={"flex"} alignItems={"center"} gap={1} justifyContent={"end"}>
                        <Typography fontSize={14}>{memberDetails.referral_code}</Typography>
                        <MdOutlineContentCopy/>
                        </Box>
                       
                        </Box>
                  
                    </Box>
                    <Box my={2}>
                     <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5} >
                          <Typography fontWeight={600} fontSize={15}>Recent Activity</Typography>
            
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
                     </Box>
                     <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                      <Box display={"flex"} gap={1} alignItems={"center"}>
                      <AiOutlinePlus color='#3FBEAC' size={20}/>
                      <Typography color='#535353' fontSize={14}>Earned 150 points</Typography>
                      </Box>
                      <Typography color='#535353' fontSize={14}>May 31, 2025</Typography>
                     </Box>
                     <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                      <Box display={"flex"} gap={1} alignItems={"center"}>
                      <HiOutlineMinus color='#A80101' size={20}/>
                      <Typography color='#535353' fontSize={14}>Redeemed 500 points</Typography>
                     
                      </Box>
                       <Typography color='#535353' fontSize={14}>May 31, 2025</Typography>
                     </Box>
                       <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                      <Box display={"flex"} gap={1} alignItems={"center"}>
                      <AiOutlinePlus color='#3FBEAC' size={20}/>
                      <Typography color='#535353' fontSize={14}>Earned 230 points</Typography>
                      </Box>
                      <Typography color='#535353' fontSize={14}>May 31, 2025</Typography>
                     </Box>
                       <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} my={1.5}>
                      <Box display={"flex"} gap={1} alignItems={"center"}>
                      <IoIosTrendingUp color='#FEB91E' size={20}/>
                      <Typography color='#535353' fontSize={14}>Tier upgraded to Platinum</Typography>
                      </Box>
                      <Typography color='#535353' fontSize={14}>May 31, 2025</Typography>
                     </Box>
                    </Box>
                    <Box my={1} borderRadius={3} p={2} bgcolor={"#ECF9F7"}>
                     <Typography fontWeight={600}>Tier Progress</Typography>
                     <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                       <Box>
                        <Typography fontSize={14} my={.5}>You are <span className='fw-bold'>2,150 </span> points away from Diamond tier</Typography>
                              <LinearProgress
                                variant="determinate"
                                value={85}
                                sx={{ height: 7, borderRadius: 4, backgroundColor: "#DADADA", flex: 1,  width:"100%", 
                                "& .MuiLinearProgress-bar": { backgroundColor: "#3FBEAC", borderRadius: 10, } }}
                      />
                      <Typography mt={.5} fontSize={14}>12,850 / 15,000 pts</Typography>
                       </Box>
                       <Box>
                            <Box
                sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    bgcolor: "#3FBEAC",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <IoTrophyOutline
                size={30}
                color='#fff'
                
                />
            </Box>

                       </Box>
                     </Box>
                    </Box>
                    <Box mt={3}>
                        <Button sx={{bgcolor:"#000000", color:"#ffffff", px:5, py:1 , width:"100%", borderRadius:2, mt:3, textTransform:"capitalize", fontSize:18 }}>View Full Profile</Button>
                    </Box>
                    </Modal.Body>
    
                </Modal>
      <Box>
                          <Grid container spacing={2} sx={{ py: 3 }} alignItems="stretch">
                    {membersStats.map((item) => (
                        <Grid item xs={12} sm={6} md={3} key={item.title} sx={{ display: "flex" }}>
                            <Card
                                elevation={0}
                                sx={{
                                    border: "1px solid #ECECEC",
                                    boxShadow: "0px 1px 4px rgba(0,0,0,0.04)",
                                    borderRadius: 3,
                                    px: 2.5,
                                    py: 2,
                                    width: "100%",
                                }}
                            >
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                    <Box component="img" src={statusIcon} alt="status" sx={{ width: 24, height: 24 }} />
                                    <Typography fontWeight={600} fontSize={14}>{item.title}</Typography>
                                </Box>
                                <Typography fontWeight={700} fontSize={22} sx={{ mt: 1 }}>{item.value}</Typography>
                                <Typography color="text.secondary" fontSize={12}>{item.subtitle}</Typography>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                 <Grid container spacing={2} alignItems="end" justifyContent={"space-between"}  sx={{ my: 1, pb: 3, }}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        placeholder="Search by name, phone or email"
                                        size="small"
                                        fullWidth
                                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" } }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <SearchIcon sx={{ color: "#888", fontSize: 20 }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={9} >
                                    <Grid container spacing={2} justifyContent={"end"}  >
                                        <Grid item xs={12} md={2} >
                                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Tier</Typography>
                                    <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                                        <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                            <MenuItem value="all">All Tiers</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                
                                <Grid item xs={12} md={2}>
                                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Status</Typography>
                                    <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                                        <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                            <MenuItem value="all">All Status</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                
                                <Grid item xs={12}  md={2}>
                                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Points Balance</Typography>
                                    <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                                        <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                            <MenuItem value="all">All</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                
                                <Grid item xs={12}  md={3}>
                                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Join Date</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={["DatePicker"]} sx={{ pt: 0, "& .MuiFormControl-root": { width: "100%" } }}>
                                            <DatePicker
                                                sx={{ width: "100%", "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14, overflow:"hidden" } }}
                                                format="DD,MM,YYYY"
                                                slotProps={{ textField: { size: "small", placeholder: "All Time", fullWidth: true } }}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Grid>
                                    </Grid>
                                </Grid>
               
                            
                            </Grid>
                               <Box>
                                <Paper elevation={0} sx={{ mb: 1, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                                    <Typography fontSize={16} fontWeight={600}>Members</Typography>
                
                                    {selectedInfoRows.length > 0 && (
                                        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                                            <Box display="flex" alignItems="center">
                                                <Checkbox
                                                    checked
                                                    checkedIcon={
                                                        <Box sx={{ width: 22, height: 22, borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#000" }}>
                                                            <CheckIcon sx={{ color: "#fff", fontSize: 18 }} />
                                                        </Box>
                                                    }
                                                    size="small"
                                                />
                                                <Typography fontSize={14}>{selectedInfoRows.length} selected</Typography>
                                            </Box>
                
                                            <Divider orientation="vertical" flexItem sx={{ borderColor: "#BCBCBC" }} />
                
                                            <Typography fontSize={14}>Bulk actions:</Typography>
                
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                <button style={{ border: "1px solid #04B22E33", fontSize: 14 }} className="btn px-3 d-flex align-items-center gap-1" onClick={handleActivate}>
                                                    <SlPresent color="#04B22E" /> Add Bonus Points
                                                </button>
                                                <button style={{ border: "1px solid #FEB91E4D", fontSize: 14 }} className="btn px-3 d-flex align-items-center gap-1" onClick={handlePause}>
                                                    <FaRegStar color= "#FEB91E" /> Change Tier
                                                </button>
                                              
                                            </Stack>
                
                                            <Divider orientation="vertical" flexItem sx={{ borderColor: "#BCBCBC" }} />
                
                                            <button style={{ color: "#535353", fontSize: 14 }} className="btn btn-outline-light px-3 d-flex align-items-center gap-1" onClick={handleReset}>
                                                <CloseOutlined sx={{ color: "#535353" }} /> Clear Selection
                                            </button>
                                        </Box>
                                    )}
                                </Paper>
                
                                <Box className="data-grid-small" sx={{ width: "100%", overflowX: "auto" }}>
                                    <Paper sx={{ minWidth: 900, "& .MuiDataGrid-cell": { fontSize: 13 }, "& .MuiDataGrid-columnHeaderTitle": { fontSize: 14, fontWeight: 600 } }}>
                                        <DataGrid
                                            rows={membersRows}
                                            columns={membersColumns}
                                            initialState={{ pagination: { paginationModel } }}
                                            pageSizeOptions={[5, 10, 20, 50]}
                                            checkboxSelection
                                            onRowSelectionModelChange={(newSelection) => {
                                                setSelectedRows(newSelection);
                                                setSelectedInfoRows(newSelection);
                                            }}
                                            sx={{ overflow: "hidden" }}
                                            slotProps={{ pagination: { sx: { justifyContent: "end", display: "flex", alignItems: "center" } } }}
                                        />
                                    </Paper>
                
                                </Box>
                            </Box>
                
          </Box>
    </>
  )
}

export default Members